import {BASE_URL} from '../../configuration/apiconfig';
import UserStore from '../../store/UserStore';

export default class ReferralService{
    key =localStorage.getItem('apiKey')
    //get the referral members
    async getReferral(level='all',offset=0,limit=20){
        const response = await fetch(BASE_URL+'tree/referral_members?level='+level+'&offset='+offset+'&limit='+limit, {     //url
            method: 'GET',                 //method
            headers : {                     //passing header 
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json',
                'api-key'       : this.key,
                'access-token'  : UserStore.key
            }
        })
        const legStatus = await response.json();
        return legStatus;
    }
}